import Component from './direct_message_queue_table.vue'
export default Component
